import { useParams } from 'react-router-dom'
import AnalyticsDetail from './AnalyticsDetail'
import AnalyticsList from './AnalyticsList'

/** `/analytics` is the portfolio; `/analytics/:appId` is one bundle id. */
export default function Analytics() {
  const { appId } = useParams()
  if (appId) return <AnalyticsDetail appId={decodeURIComponent(appId)} />
  return <AnalyticsList />
}
